import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { TranslocoModule } from '@ngneat/transloco';

import { OrderIdFieldModule } from '@dsh/app/shared/components/inputs/order-id-field';
import { FilterModule } from '@dsh/components/filter';

import { OrderIdFilterComponent } from './order-id-filter.component';

@NgModule({
    imports: [CommonModule, TranslocoModule, OrderIdFieldModule, ReactiveFormsModule, FilterModule],
    declarations: [OrderIdFilterComponent],
    exports: [OrderIdFilterComponent],
})
export class OrderIdFilterModule {}
